import React from 'react';
import { TextProps, Text } from '@cad-arc';
import { differenceInDays, differenceInHours, differenceInMinutes } from 'date-fns';
import { useDurationSince } from '../hooks/use-duration-since';
import { useNow } from '../hooks/use-now';

export function FormattedDurationSince({
    date,
    ...props
}: TextProps & {
    date: Date;
}): React.ReactElement {
    const now = useNow();
    const duration = useDurationSince({ date });
    if (duration.years || duration.months || duration.days) {
        return (
            <Text as="span" {...props}>
                {differenceInDays(now, date)}d
            </Text>
        );
    } else if (duration.hours) {
        return (
            <Text as="span" {...props}>
                {differenceInHours(now, date, { roundingMethod: 'round' })}h
            </Text>
        );
    } else {
        return (
            <Text as="span" {...props}>
                {differenceInMinutes(now, date)}m
            </Text>
        );
    }
}
